<template>
  <div class="bg-white rounded-2xl shadow-md p-4">
    <div class="flex items-center justify-between mb-4">
      <h3 class="text-lg font-bold text-gray-900">Contrat</h3>
      <div class="flex items-center gap-2">
        <FieldSpan v-if="claim.category" class="bg-blue-100 text-blue-800" :value="claim.category" />
        <FieldSpan
          :class="[statusBadgeClass(planSale)]"
          translation-prefix="planSale.status"
          :value="planSale.status"
        />
      </div>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2">
      <StackedField label="Numéro contrat" class="col-span-2">
        <router-link
          class="font-light text-primary hover:text-primary-dark cursor-pointer"
          :to="`/plan-sales/${planSale.friendlyId}`"
        >
          {{ planSale.friendlyId }}
        </router-link>
      </StackedField>
      <StackedField label="Adhérent" :value="`${customer.firstName} ${customer.lastName}`" />
      <StackedField label="Date d'adhésion" :value="planSale.date" />
      <StackedField label="Date d'expiration" :value="planSaleExpiration" />
      <StackedField label="Renouvellement" :value="planSale?.renewal ? 'Oui' : 'Non'" />
      <StackedField label="Max. prise en charge" class="col-span-2" :value="formatPrice(claim.compensationValue)" />
      <StackedField label="Limite prise en charge" class="col-span-2" :value="claim?.claimLimit?.description" />
      <template v-if="planSale.renewal && planSale.originalPlanSale">
        <StackedField label="Date d'adhésion du contrat précédent" :value="planSale.originalPlanSale?.date" />
        <StackedField label="Numéro contrat précédent">
          <router-link
            class="font-light text-primary hover:text-primary-dark cursor-pointer"
            :to="`/plan-sales/${planSale.originalPlanSale?.friendlyId}`"
          >
            {{ planSale.originalPlanSale?.friendlyId }}
          </router-link>
        </StackedField>
      </template>
      <StackedField v-if="customer.iban" label="IBAN du client">
        <CopyToClipboard :textToCopy="customer.iban.value">
          <span class="cursor-pointer text-primary hover:text-primary-dark font-light">Copier</span>
        </CopyToClipboard>
      </StackedField>
    </div>
  </div>
</template>

<script>
import { CopyToClipboard, FieldSpan, StackedField, formatPrice } from "@estaly/ui";
import { mapGetters } from "vuex";

export default {
  props: ["claim"],
  components: {
    CopyToClipboard,
    FieldSpan,
    StackedField,
  },

  computed: {
    ...mapGetters("planSales", ["statusBadgeClass"]),

    planSale() {
      return this.claim.planSale;
    },

    claimProduct() {
      return this.claim.claimProduct;
    },

    customer() {
      return this.claim.customer;
    },

    planSaleExpiration() {
      return this.planSale.recurring ? "Tacite reconduction" : this.planSale.expirationDate;
    },
  },

  methods: {
    formatPrice,
  },
};
</script>
